import { HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";
import { Ref } from "react";
import { CreatePdfDefinitionRequest, PdfDisplayDefinition  } from "interfaces/Phoenix.FormsDesigner.Models";
import { pdfImportChanges } from "components/PhoenixFormsV4/PhoenixFormsDesigner/PDFDesigner/ImportChangesDialog";


export const createPdfDefinition = (pdfDef: CreatePdfDefinitionRequest, successCallback: (pdfDef: PdfDisplayDefinition) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: pdfDef,
  endpoint: `/phoenix-pdf-designer/pdf`,
  successCallback,
  mountedRef,
});

export const getPdfDefinition = (phoenixFormId: string, successCallback: (pdfDef: PdfDisplayDefinition) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenix-pdf-designer/pdf/${phoenixFormId}/definition`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const updatePdfDefinition = (phoenixFormId: string, pdfDef: PdfDisplayDefinition, successCallback: (pdfDef: PdfDisplayDefinition) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  payload: pdfDef,
  endpoint: `/phoenix-pdf-designer/pdf/${phoenixFormId}`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const importPdfChanges = (phoenixFormId: string, successCallback: (changes: pdfImportChanges) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenix-pdf-designer/pdf/${phoenixFormId}/import`,
  successCallback,
  errorCallback,
  mountedRef,
});